var render = function render() {
  var _vm = this,
      _c = _vm._self._c;return _c('el-popover', { attrs: { "placement": "right", "width": "80", "trigger": "hover", "popper-class": "res-custom-popover", "disabled": _vm.disabled } }, [_c('ul', { staticClass: "action-more-list" }, [_c('li', [_vm._t("model-download-btn")], 2), _vm._v(" "), _c('li', [_vm._t("texture-download-btn")], 2)]), _vm._v(" "), _c('el-button', { attrs: { "slot": "reference", "type": "text", "disabled": _vm.disabled }, slot: "reference" }, [_vm._v(_vm._s(_vm.text))])], 1);
};
var staticRenderFns = [];

export { render, staticRenderFns };